 import axios from 'axios'

const state = () => ({
  kurslar: []
})

const getters = {
  kurslar(state) {
    return state.kurslar
  }
}

const mutations = {
  SET_KURSLAR(state, payload){
    state.kurslar = payload
  }
}

const actions = {
  getKurslar({commit}){
    axios.get('https://api.geomalaka.uz/api/about/kurslar/')
    .then((res)=>{
      commit("SET_KURSLAR", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
